import { create } from "zustand";

export type ThemeMode = "light" | "dark" | "system";

interface ThemeState {
  mode: ThemeMode;
  setMode: (mode: ThemeMode) => void;
}

const STORAGE_KEY = "pec-theme-mode";

function applyTheme(mode: ThemeMode) {
  const root = document.documentElement;
  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  const effective = mode === "system" ? (prefersDark ? "dark" : "light") : mode;
  root.classList.toggle("dark", effective === "dark");
  root.dataset.theme = effective;
}

export const useThemeStore = create<ThemeState>((set) => ({
  mode: ((): ThemeMode => {
    const stored = window.localStorage.getItem(STORAGE_KEY) as ThemeMode | null;
    return stored ?? "system";
  })(),
  setMode: (mode) => {
    window.localStorage.setItem(STORAGE_KEY, mode);
    applyTheme(mode);
    set({ mode });
  }
}));

export function initTheme() {
  const mode = window.localStorage.getItem(STORAGE_KEY) as ThemeMode | null;
  applyTheme(mode ?? "system");
}
